import { notify } from '../../actions/notifications';
import { changeFrequency } from '../../actions/savedSearches/actions';
import {
  TWebCreateSubscriptionResponse,
  fetchWebCreateSubscription,
} from '../../repositories/saved-searches/v1/web/create-subscription';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';
import { EFrequency } from '../../types/savedSearch';

export interface ISubscribeToSavedSearchParameters {
  id: number;
  frequency: EFrequency;
  email: string | null;
}

export const subscribeToSavedSearch =
  ({ id, frequency, email }: ISubscribeToSavedSearchParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () =>
      dispatch(notify('Что-то пошло не так. Попробуйте повторить попытку позже', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TWebCreateSubscriptionResponse = await fetchWebCreateSubscription({
        httpApi,
        parameters: {
          email: email || '',
          frequency,
          savedSearchId: id,
          subscribeNews: false,
        },
      });

      if (statusCode === 200) {
        dispatch(changeFrequency({ id, frequency, status: 'inactive' }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Failed subscribe saved searches (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, { description: 'Failed subscribe saved searches' });
    }
  };
